export default "__VITE_ASSET__Dcz39SfK__"